import "../../assets/scss/components/sections/authentication/authentication.scss";

import logo from "../../assets/images/authentication/logo.svg";
import loading from "../../assets/images/loading.svg";
import { Form, Image } from "react-bootstrap";

import google from "../../assets/images/authentication/google.svg";
import CustomCheckBox from "../../components/templates/customCheckBox";
import axios from "axios";
import {
  getBaseApiURL,
  console_log,
  showToast,
} from "../../utils/commonHelper";
import { useEffect, useState } from "react";
import {
  getLocalStorage,
  setCookie,
  setLocalStorage,
} from "../../utils/userHelper";
import { useNavigate } from "react-router-dom";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { checkExistingFileToDownload } from "./helper";

const Login = () => {
  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisableGoogleLogin, setIsDisableGoogleLogin] = useState(false);

  useEffect(() => {
    console.log("login screen calling");
    const urlParams = new URLSearchParams(window.location.search);
    const jobURL = urlParams.get("jobURL"); // Gets the value of "abc"

    if (jobURL !== null && jobURL !== undefined && jobURL !== "") {
      setLocalStorage("job_url", jobURL);
    }
  }, []);

  const sendRequest = (type = "email", data) => {
    console.log(type);
    if (type == "email") setIsDisabled(true);

    let url = getBaseApiURL() + `/auth/login`;

    if (type == "google") url = getBaseApiURL() + `/auth/google-auth`;

    axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json", // Set content type
        },
      })
      .then((response) => {
        if (type == "email") setIsDisabled(false);
        let data = response.data;
        // console_log("data", data);
        setCookie("access_token", data.access_token);
        setCookie("id_token", data.id_token);
        setCookie("refresh_token", data.refresh_token);
        setIsDisableGoogleLogin(false);
        checkExistingFileToDownload(navigate);
      })
      .catch((error) => {
        if (type == "email") setIsDisabled(false);
        console_log("error", error);
        showToast(error, "error");
      });
  };

  const clickedLoginButton = () => {
    if (emailAddress == "" || password == "") {
      // console_log("error");
      showToast("Email Or Password Field is required", "error");
    } else {
      sendRequest("email", {
        email: emailAddress,
        password: password,
      });
    }
  };

  // Google login response handler
  const responseMessage = (response) => {
    setIsDisableGoogleLogin(true);
    console_log("default", response);
    sendRequest("google", {
      token: response.access_token,
    });
  };
  const errorMessage = (error) => {
    setIsDisableGoogleLogin(false);
    showToast(error);
  };

  const GoogleLoginFunc = useGoogleLogin({
    onSuccess: responseMessage,
    onError: errorMessage,
    scope: "", // Ensure "openid" is included to receive ID token
  });

  const clickedGoogleLoginButton = useGoogleLogin({
    onSuccess: responseMessage,
    onError: errorMessage,
    scope: "", // Ensure "openid" is included to receive ID token
  });

  return (
    <div className="login-section authentication">
      <div className="login">
        <div className="logo">
          <Image src={logo} />
        </div>
        <div className="form">
          <h4 className="heading-4">Login</h4>
          <div>
            <Form>
              <Form.Group className="mb-3">
                <Form.Control
                  type="email"
                  placeholder="Email Address"
                  value={emailAddress}
                  onInput={(e) => setEmailAddress(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={password}
                  onInput={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <div className="remember-forget">
                <CustomCheckBox text="Remember Me" />
                <a href="/forgot" className="forget">
                  Forget Password?
                </a>
              </div>
              <button
                type="button"
                className="btn-primary z-2 position-relative btn btn-primary"
                onClick={clickedLoginButton}
                disabled={isDisabled}
              >
                <span>Continue with Email</span>
                <img className="loading-icon" src={loading} alt="" />
              </button>
            </Form>
          </div>
          <p className="paragraph-main-regular text-center do-you-have-account">
            Don’t Have an Account?
            <a href="/signup" className="link">
              Create One
            </a>
          </p>
          <p className="or">OR</p>
          <div>
            <button
              type="button"
              className=" z-2 position-relative btn btn-outline google-button"
              onClick={clickedGoogleLoginButton}
              disabled={isDisableGoogleLogin}
            >
              <img className="" src={google} alt="" />
              <span class="ml-1"> Continue with Google</span>
              <img
                src={loading}
                alt=""
                style={{
                  display: !isDisableGoogleLogin && "none",
                  width: "30px",
                  color: "black",
                  animation: "spin 0.5s linear infinite",
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
